import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import PaymentPage from '../../ADP/Components/PaymentPage';
import styles from './form.module.scss';
import Loading from '../../../../components/loading';
import Button from '../../../../components/button/button';
import { GetFileName, S3Uploads } from '../../../services';
import HeaderBack from '../../../../components/headerBack';
import permitModule from '../../../../icons/PERMITMODULE.png';
import ReqAttachments from '../../ADP/Components/ReqAttachments';
import SectionHeader from '../../../../components/sectionHeader';
import { changeCurrentPage } from '../../../../general_redux/actions';
import Collapsible from '../../../../components/collapsible/Collapsible';
import CustomFields from '../../../../components/customFields/CustomFields';
import badgeStyles from '../../../Badging/Detail/detail.module.scss';
import { clearDraftState, fetchspecificAvpLogs, getAvpDefaultFields, initiateAvpApplication,
  initiateDraftAvp, deleteSaveAsDraftAvpLog, clearApproveApplicationInfo, checkApprovedApplication,
  getAvpCategories, getAvpFeeMatrix, makeAvpPayment } from '../../redux/action';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import DeleteConfirmation from '../../../../components/deleteConfirmation/deleteConfirmation';
import { customSort, getAnswerUpdates, getTitles, handleSignature, validateFieldErrors, valueType } from '../../components/PermitData';
import Modal from '../../../../components/modal';
import { getAddress } from '../../../../utils/helpers';
import Clickable from '../../../../components/clickable/Clickable';
import closeIcon from '../../../../icons/closeIcon.svg';
import { getFeeWithInvoice, SaveAlert } from '../../components/ActionCompo';
import OfflinePayment from '../../ADP/Components/OfflinePayment';


// reusable component for Length, Width, Height fields
const DimensionInput = ({ label, value, onChange }) => (
  <div className={styles.lengthInputChildContainer}>
    <label htmlFor="dimension" style={{ margin: 0 }}>{label}</label>
    <input
      type="number"
      className={styles.dimensionInput}
      onChange={onChange}
      value={value}
    />
    <label htmlFor="dimension" style={{ margin: 0 }}>Meters</label>
  </div>
);

const AvpInitiateForm = (props) => {
  const { history } = props;

  const logId = props?.match?.params?.id;
  const dispatch = useDispatch();
  const profile = useSelector(states => states?.auth?.profile);
  const defaultFields = useSelector(states => (logId
    ? states?.permitManagement?.avpDSchema
    : states?.permitManagement?.avpDefaultFields));
  const avpSettings = useSelector(states => states?.permitManagement?.avpSettings);
  const approvedApplicationAction = useSelector(state => state?.permitManagement?.actionForApprovedAppCheck);
  const approvedAppInfo = useSelector(state => state?.permitManagement?.approvedApplicationData);
  const customFields = useSelector(states => (logId
    ? states?.permitManagement?.avpCSchema
    : states?.permitManagement?.avpCustomFields));
  const loader = useSelector(states => states?.permitManagement?.avpInitiationStatus);
  const loaderForRenewal = useSelector(states => states?.permitManagement?.loader);
  const ordering = useSelector(states => (logId
    ? states?.permitManagement?.avpOrder
    : states?.permitManagement?.avpOrdering));
  const reqAttach = useSelector(state => (logId
    ? state.permitManagement?.avpRequiredAttachments
    : state.permitManagement?.avpReqAttachments));
  const notes = useSelector(states => states?.permitManagement?.avpNotes);
  const applicationDetails = useSelector(states => states?.permitManagement?.avpSpecificLog);
  const avpDraftStatus = useSelector(states => states?.permitManagement?.avpDraftStatus);
  const actionDeleteDraftApplication = useSelector(states => states?.permitManagement?.actionDeleteDraftAVPApplication);
  const avpCategoryList = useSelector(states => states?.permitManagement?.avpCategoryList);
  const feeTypesList = useSelector(states => states?.permitManagement?.avpFeeMatrix);
  const avpGetSchemaSettings = useSelector(s => s?.permitManagement?.avpGetSchemaSettings);
  const avpInitiationInfo = useSelector(state => state?.permitManagement?.avpInitiationInfo);
  const paymentActionInfo = useSelector(state => state?.permitManagement?.getAvpPaymentAction);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [reqErrors, setReqErrors] = useState({});
  const [allFields, setAllFields] = useState([]);
  const [conditionalFields, setConditionalFields] = useState({});
  const [approvedData, setApprovedAppInfo] = useState('');
  const [errors, setErrors] = useState({
    attachments: true,
    signature: true
  });
  const [state, setState] = useState({
    answers: {
      length: '',
      width: '',
      height: '',
      attachments: [],
      req_attachments: {},
      dateError: false
    },
    formErrors: false,
    loader: false
  });

  const [currentStep, setCurrentStep] = useState('application');

  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [haveDimensionFields, setHaveDimensionFields] = useState(false);

  // fixed fields - Attachments and Signature
  const staticFields = [
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'attachments',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Attachments',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'signature',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Signature',
      type: 'signature'
    }
  ];

  // used for differentiate the default and custom fields
  const defaultIDs = [
    'first_name', 'last_name', 'phone', 'email', 'company_address', 'purpose_of_vehicle', 'year_of_reg',
    'category_of_veh_equp', 'vrea', 'insurance_validity', 'veh_powered_by',
    'tpaa', 'type_of_veh_equp', 'tpao', 'reg_no_veh_eqpt', 'pc_validity',
    'type_of_issue', 'employee_id', 'make_type', 'veh_insurance_company',
    'location_of_parking', 'category_of_avp', 'designation', 'signature',
    'length', 'height', 'width'
  ];

  useEffect(() => {
    dispatch(changeCurrentPage(profile?.permit_management?.vehicle_permit || 'AVP'));
    dispatch(getAvpDefaultFields());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getAvpCategories());
    localStorage.removeItem('noPaymentForDraft');
  }, [dispatch]);

  useEffect(() => {
    if (!approvedApplicationAction?.loading && approvedApplicationAction?.success) {
      dispatch(clearApproveApplicationInfo());
      setApprovedAppInfo(approvedAppInfo);
      // IF ANY APPROVED PERMITS EXISTS, THEN WILL PREVENT THE ININTIATION OF NEW APPLICATION
      // AND WILL DISPLAY THE WARNING MESSAGE
      if (approvedAppInfo?.count) {
        setState(prevState => ({
          ...prevState,
          openApprovalWarning: true
        }));
      } else {
        handelSubmit(false, true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approvedApplicationAction]);

  useEffect(() => {
    if (logId) {
      dispatch(fetchspecificAvpLogs(logId));
    } else {
      dispatch(clearDraftState());
    }
  }, [logId, dispatch]);

  useEffect(() => {
    if (((avpDraftStatus?.success || avpDraftStatus?.error)
        && (localStorage.getItem('noPaymentForDraft') === 'true'
          || !(avpSettings?.enablePermitFees && avpGetSchemaSettings?.charge_fees_per_avp_permit))
        )
      || (actionDeleteDraftApplication?.success || actionDeleteDraftApplication?.error)
      || (paymentActionInfo?.success || paymentActionInfo?.error)
    ) {
      dispatch(clearDraftState());
      history.push('/avp/logs');
    }
    if ((avpDraftStatus?.success || avpDraftStatus?.error) && avpSettings?.enablePermitFees && avpGetSchemaSettings?.charge_fees_per_avp_permit
      && localStorage.getItem('noPaymentForDraft') !== 'true') {
      setCurrentStep('payment');
    }
  }, [avpDraftStatus, history, dispatch, actionDeleteDraftApplication, paymentActionInfo, avpSettings, avpGetSchemaSettings]);

    useEffect(() => {
      if (profile?.current_tenant?.id) dispatch(getAvpFeeMatrix(profile?.current_tenant?.id));
    }, [profile, dispatch]);

  useEffect(() => {
    if ((avpDraftStatus?.success || avpDraftStatus?.error) && applicationDetails?.vehicle_info?.imported) {
      history.push('/avp/logs');
    }
  }, [history, avpDraftStatus, applicationDetails]);

  useEffect(() => {
    let newAnswersObject = state?.answers;
    if (logId && Object.keys(applicationDetails || {}).length > 0) {
      newAnswersObject = applicationDetails;
      setState(prev => ({
        ...prev,
        answers: {
          ...prev.answers,
          ...newAnswersObject,
          length: newAnswersObject?.length === '0.00' ? '' : newAnswersObject?.length,
          width: newAnswersObject?.width === '0.00' ? '' : newAnswersObject?.width,
          height: newAnswersObject?.height === '0.00' ? '' : newAnswersObject?.height
        }
      }));
    }
    if (defaultFields && customFields) {
      const default_fields = defaultFields.map((ele) => {
        if (['first_name', 'last_name', 'phone', 'email'].includes(ele.id)) {
          return {
            ...ele,
            disable: true,
            type: 'string'
          };
        }
        if (ele.id === 'type_of_issue') {
          return {
            ...ele,
            values: [{
              key: 'New',
              value: 'New'
            }],
            disable: true,
            default_value: {
              key: 'New',
              value: 'New'
            }
          };
        }
        return ele;
      });
      const fIds = default_fields?.map(f => f.id);
      const hasLWH = ['length', 'width', 'height'].every(fId => fIds?.includes(fId));
      setHaveDimensionFields(hasLWH);
      const combinedFields = [...default_fields, ...customFields];
      let mergedFields;
      let condFields = {};
      let fieldErros = { ...errors,
        signature: newAnswersObject?.signature ? !Object.keys(newAnswersObject?.signature) : true,
        attachments: newAnswersObject?.attachments ? !Object.keys(newAnswersObject?.attachments) : true
      };
      if (!hasLWH) {
        fieldErros = { ...fieldErros, length: true, width: true, height: true };
      }
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering && ordering?.length) { // sorted - if ordering
        mergedFields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        mergedFields = filteredFields; // without sorted - if no ordering
      }
      setAllFields(mergedFields);
      mergedFields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else if (ele.required) {
          if (defaultIDs.includes(ele.id)) {
            if (['date', 'datetime'].includes(ele.type) && ele.default) {
              fieldErros = { ...fieldErros, [ele.id]: false };
            } else {
              fieldErros = { ...fieldErros, [ele.id]: !newAnswersObject?.[ele.id] };
            }
          } else {
            fieldErros = { ...fieldErros, [ele.id]: (!newAnswersObject.response?.[ele.id]) };
          }
        }
      });
      setConditionalFields(condFields);
      setErrors(fieldErros);
    } else {
      dispatch(getAvpDefaultFields());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, defaultFields, applicationDetails]);

  useEffect(() => {
    if (!allFields || allFields.length === 0) return;

    const optAnswers = { response: {} };
    const optionalFields = allFields.filter(field => !field.required && !field.conditional);
    optionalFields.forEach((each) => {
      if (defaultIDs.includes(each.id)) {
        optAnswers[each.id] = state.answers[each.id]
          ? state.answers[each.id]
          : valueType(each)?.value;
      } else {
        optAnswers.response[each.id] = state.answers.response?.[each.id]
          ? state.answers.response?.[each.id]
          : valueType(each)?.value;
      }
    });

    const sign = applicationDetails.signature;
    const isEmptySignature = (Array.isArray(sign) && sign.length === 0)
        || (Array.isArray(sign) && sign.length === 1 && Object.keys(sign[0]).length === 0);

    const { first_name, last_name, phone, current_tenant, user } = profile;
    const userData = {
      first_name,
      last_name,
      phone,
      email: user?.email || '',
      company_address: getAddress(current_tenant?.updated_address?.[0]|| current_tenant?.address?.[0])
    };

      const all_attachments = (applicationDetails?.attachments || [])?.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = applicationDetails?.req_attachments
        && Object.keys(applicationDetails?.req_attachments || {})
        .reduce((acc, key) => ({ ...acc, [key]: applicationDetails?.req_attachments[key].map(att => all_attachments[att]) }), {});

    setState(prevState => ({
      ...prevState,
      answers: {
        ...prevState.answers,
        ...optAnswers,
        ...userData,
        req_attachments: requireAttachments,
        signature: isEmptySignature ? null : applicationDetails.signature,
        response: {
          ...optAnswers.response,
          ...(prevState.answers.response || {})
        }
      }
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFields]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  }, [state.answers.req_attachments, reqAttach]);

  useEffect(() => {
    if (loader?.success) {
      if (avpSettings?.enablePermitFees && avpGetSchemaSettings?.charge_fees_per_avp_permit && localStorage.getItem('noPaymentForDraft') !== 'true') {
        setCurrentStep('payment');
      } else {
        history.push('/avp/logs'); // redirected after form submission completed
      }
    }
  }, [loader, history, avpSettings, avpGetSchemaSettings, state]);

  useEffect(() => () => {
    dispatch(clearDraftState());
  }, [dispatch]);

  const handleAnswerChanged = (section, answer, fieldId) => {
    const { updates, errorUpdates } = getAnswerUpdates({
      section,
      answer,
      fieldId,
      allFields,
      conditionalFields,
      currentAnswers: state.answers,
      defaultIDs
    });

    // ---------- state update ----------
    setState(prev => ({
      ...prev,
      answers: {
        ...prev.answers,
        ...updates,
        response: {
          ...prev.answers.response,
          ...(updates.response || {})
        }
      }
    }));

    // ---------- error update ----------
    setErrors(prev => ({
      ...prev,
      ...errorUpdates
    }));
  };

  const handleFieldErrorChanged = (id, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [id]: value }));
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers?.attachments?.filter(e => e?.attachment_id !== attachment?.attachment_id);
    setState({ ...state, answers: { ...state.answers, attachments: filtereAttachments } });
  };

  const getRequired = (data, isFieldError = false) => {
    let requiredKeys = { // static fields for required
      attachments: true,
      signature: true
    };
    if (!haveDimensionFields) requiredKeys = { ...requiredKeys, length: true, width: true, height: true };
    let FieldError = { ...errors };
    if (data?.length !== 0) {
      data.forEach((ele) => {
        if (ele.required) { // checking required fields
          if (defaultIDs.includes(ele.id)) { // checking required default fields
            requiredKeys = { ...requiredKeys, [ele.id]: ele.required };
            FieldError = { ...FieldError, [ele.id]: !state.answers[ele.id] };
          } else if (!(defaultIDs.includes(ele.id))) { // checking required fields
            requiredKeys = { ...requiredKeys, [ele.id]: ele.required };
            FieldError = { ...FieldError, [ele.id]: !state.answers?.response?.[ele.id] };
          }
        }
      });
    }
    return isFieldError ? FieldError : requiredKeys;
  };

  const handleChange = dimension => (e) => { // for dimension field answers
    const value = e.target.value > 0 ? e.target.value : 0;
    setState(prevState => ({
      ...prevState,
      answers: {
        ...prevState.answers,
        [dimension]: value
      }
    }));
    handleFieldErrorChanged(dimension, e.target.value.length === 0);
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getPermitUploadFileName(count);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      undefined,
      undefined,
      getErrorAlert
    );
    return response;
  };

  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'vehicle_permit',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((aid) => {
          attachmentIds.push(aid.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'vehicle_permit', getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  const checkApprovedApplicationData = () => {
    if (state.answers?.[avpSettings?.identifierField?.value]) {
      const payload = {
        check_value: state.answers?.[avpSettings?.identifierField?.value] || '',
        unique_identifier: avpSettings?.identifierField?.value || ''
      };
      dispatch(checkApprovedApplication(payload));
    } else {
      handelSubmit(false, true); // if no identifierField?.value or undefined
    }
  };

  const handelSubmit = async (isDraft, noNeedApprovalCheck) => {
    const { attachments, signature, insurance_validity, pc_validity, length, width, height, req_attachments } = state.answers;
    let dataObject = {};
    let error = validateFieldErrors(state.answers, allFields, defaultIDs, handleFieldErrorChanged, haveDimensionFields);
    error = { ...error, attachments: !reqAttach?.length > 0 ? !state.answers.attachments?.length : false };
    let noErrors = Object.keys(error).every(k => error[k] === false);
    let noReqErrors = Object.keys(reqErrors).every(k => reqErrors[k] === false);
    if (!isDraft && pc_validity && moment(pc_validity).diff(moment(new Date())) < 0) {
      setState(prevState => ({
        ...prevState,
        dateError: `${getTitles(allFields, 'pc_validity') || 'Pollution certificate validity Date'}
          should be a future date. Please modify the date and try again.`
      }));
    } else if (!isDraft && insurance_validity && moment(insurance_validity).diff(moment(new Date())) < 0) {
      setState(prevState => ({
        ...prevState,
        dateError: `${getTitles(allFields, 'insurance_validity') || 'Insurance validity Date'}
          should be a future date. Please modify the date and try again.`
      }));
    } else if ((noErrors && noReqErrors) || isDraft) {
      // RESTRICT THE NEW APPLICATION INITIATE WITH SPECIFIC IDENTIFIER
      // WHICH IS SELECTED ON ADMIN CONSOLE SETTING
      if (isEnabledApprovedAppCheck && !noNeedApprovalCheck && !isDraft) {
        checkApprovedApplicationData();
        return;
      }
      setState(prevState => ({ ...prevState, loader: true, dateError: '' }));

      const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
        if (Array.isArray(attachment)) {
          acc[key] = attachment
            .map(item => item?.attachment_id)
            .filter(aid => typeof aid === 'string');
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});
      const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
        ? attachments.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];
      const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'vehicle_permit');

      const customSignFields = allFields.filter(field => field.type === 'signature') || [];

      if (customSignFields.length > 0) {
        for (let index = 0; index < customSignFields.length; index++) {
          const customSignField = customSignFields[index]?.id;
          const schemaField = customSignFields[index];
          const customSignValue = Array.isArray(state.answers?.response?.[customSignField])
            ? state.answers?.response?.[customSignField]
            : !!state.answers?.response?.[customSignField] && [state.answers?.response?.[customSignField]];
          if (schemaField?.type === 'signature' && customSignValue?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            state.answers.response[customSignField] = await handleUploadAttachments(customSignValue, 'vehicle_permit') || [];
          }
        }
      }

      const attachmentFields = allFields.filter(schemaField => (
        schemaField?.type === 'attachments'
      ));
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
            state.answers.response[attachmentField] = state.answers.response[attachmentField]
              .map(item => item?.attachment_id)
              .filter(id => typeof id === 'string');
          }
        }
      }
      const multiselectFields = allFields.filter(schemaField => (schemaField?.type === 'multiselect'));
      if (multiselectFields.length > 0) {
        multiselectFields.forEach((field) => {
          const fieldId = field.id;
          if (Array.isArray(state.answers?.response?.[fieldId])) {
            state.answers.response[fieldId] = customSort(state.answers.response[fieldId]);
          }
        });
      }

      const avp_category_id = avpCategoryList?.find(ele => (ele.name === state.answers?.category_of_avp && ele?.id));
      let data = {
        ...state.answers,
        status: isDraft ? 'Draft' : null,
        attachments: attachmentId,
        avp_category: avp_category_id?.id || null,
        req_attachments: attchList,
        length: length?.length > 0 ? length : 0,
        width: width?.length > 0 ? width : 0,
        height: height?.length > 0 ? height : 0,
        type_of_issue: 'New',
        signature: (signature?.length > 0 && signature[0].attachment_id)
          ? signature[0].attachment_id
          : (signatureId?.[0] || []),
        year_of_reg: state?.answers?.year_of_reg ? moment(state?.answers?.year_of_reg).format('YYYY') : null,
        pc_validity: state?.answers?.pc_validity && moment(state.answers.pc_validity).format('YYYY-MM-DD'),
        insurance_validity: state?.answers?.insurance_validity && moment(state.answers.insurance_validity).format('YYYY-MM-DD'),
        ...dataObject
      };
      if (data.phone) {
        data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
      }
      if (reqAttach?.length > 0 && Object.keys(req_attachments || {})?.length > 0) {
        data.attachments.push(...Object.values(attchList).flat());
      }
      if (allFields.length !== 0) {
        let checkbox = allFields.filter(ele => ele.type === 'boolean');
        if (checkbox?.length !== 0) {
          checkbox.forEach((ele) => {
            if (!data.response[ele.id]) {
              data={ ...data, response: { ...data.response, [ele.id]: false } };
            }
          });
        }
      }
      if (isDraft) {
        localStorage.setItem('noPaymentForDraft', true);
      }
      if (logId && (applicationDetails?.status === 14 || isDraft)) {
        dispatch(initiateDraftAvp(logId, data));
      } else {
        dispatch(initiateAvpApplication(data));
      }
      setState(prevState => ({ ...prevState, formErrors: false, loader: false, dateError: '' }));
    } else {
      setState(prevState => ({ ...prevState, formErrors: true, dateError: '' }));
    }
  };

  const getAnswers = fieldId => ( // Helper function to get answers
    defaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  const fieldAnswers = {}; // Build the answers object using a loop
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };

  const remove = () => {
    dispatch(deleteSaveAsDraftAvpLog(logId));
    setConfirmDelete(false);
  };

  const invoiceObject = useMemo(() => getFeeWithInvoice({
      description: 'On Application Submission',
      feeCategoryData: feeTypesList,
      taxData: avpGetSchemaSettings?.tax_details,
      applicationType: 'New',
      applicationFor: 'on_application_submission',
      selectedCategory: state.answers?.category_of_avp,
      isVatApplicable: avpGetSchemaSettings?.isVatApplicableForAvp,
      roundTo: 2
    }) || {}, [feeTypesList, state.answers.category_of_avp, avpGetSchemaSettings]);

  const buildPaymentInfo = useCallback(({ id, amount }) => ({
    id,
    amount,
    description: invoiceObject?.description || '',
    fee_type: invoiceObject?.fee_type,
    other_info: {
      ...invoiceObject,
      currency: profile?.portal_airport?.airport_settings?.currency || '$'
    },
    payment_by_tenant: avpGetSchemaSettings?.avp_payment_type_for_tenant === 'offline'
  }), [invoiceObject, profile, avpGetSchemaSettings]);

  const handlePayment = useCallback((tokenDetails, paymentValue, applicationId) => {
    const appId = logId || avpInitiationInfo?.id || applicationId;
    if (tokenDetails && appId) {
      const payload = {
        payment_info: buildPaymentInfo({
          id: tokenDetails?.token?.id || null,
          amount: paymentValue || 0
        })
      };

      dispatch(makeAvpPayment(appId, payload));
    }
  }, [avpInitiationInfo, buildPaymentInfo, dispatch, logId]);

  const handleOfflinePayment = useCallback((tokenDetails, payment_value, key) => {
    handlePayment(tokenDetails, payment_value, key);
  }, [handlePayment]);

  const handleSkip = () => {
    const payValue = avpGetSchemaSettings?.charge_fees_per_avp_permit
      ? invoiceObject?.grandTotal
      : 0;
    const appId = logId || avpInitiationInfo?.id;

    // Only dispatch when no payment is required
    if (payValue) {
      history.push('/avp/logs');
      return;
    }

    const payload = {
      skip_payment: true,
      payment_info: buildPaymentInfo({
        id: null,
        amount: payValue
      })
    };

    dispatch(makeAvpPayment(appId, payload));
  };

  const isEnabledApprovedAppCheck = avpSettings?.disable_more_than_one_approved_permit_avp || false;

  const isEmpty = v => Number(v) === 0 || v === '';
  const { height, length, width } = state.answers;
  const hasEmptyFields = [height, length, width].some(isEmpty);
  return (
    <>
    <Loading
      loadingStatus={loader?.loading
        || state?.loader
        || avpDraftStatus?.loading
        || (loaderForRenewal && logId)
      }
    />
    <SectionHeader
      icon={permitModule}
      translationID=" "
      defaultTitle={`Initiate ${profile?.permit_management?.vehicle_permit || 'AVP'}`}
      centered
      {...props}
    />
    <HeaderBack
      translationID="workorder.settings.back"
      translationDefault="Back"
      backRoute="/avp/logs"
    />

  {currentStep !== 'payment' && (
    <div className={styles.container}>
      {/* Header */}
      {currentStep !== 'payment' && (
      <>
      <div className={styles.headder}>
        <h4>
          <FormattedMessage id="avp.applications"
            defaultMessage="Initiate Application"
          />
        </h4>
      </div>
      <div style={{ padding: '10px' }}>
        {/* All Default and Custom fields from Schema  */}
        <CustomFields
          handleAnswerChanged={(a, b) => (handleAnswerChanged(defaultIDs.includes(b) ? 'answers': 'response', a, b))}
          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
          handleAttachmentFailedAlert={getErrorAlert}
          handleAutoUploadAttachments={uploadtoS3}
          getLoadingStatus={getLoadingStatus}
          entityName="vehicle_permit"
          showFormErrors={state.formErrors}
          requiredMap={getRequired(allFields, applicationDetails?.status === 14)}
          fields={allFields}
          answers={fieldAnswers}
          adp
          forQuestionMarkHelp
          isSignatureUpload
          canUseDataSourceFromAvp
        />
        {!haveDimensionFields && (
          <>
            <small style={{ color: 'red' }}> * </small>
            <label htmlFor="dimension">
              <FormattedMessage id="avp.vehicle.dimension"
                defaultMessage="Dimension Of Vehicle"
              />
            </label>
            {/* dimenesion fields - Length Width Height */}
            <div>
              <div className={styles.lengthinput}>
                <DimensionInput
                  label="Length"
                  value={state.answers.length}
                  onChange={handleChange('length')}
                  />
                <DimensionInput
                  label="Width"
                  value={state.answers.width}
                  onChange={handleChange('width')}
                  />
                <DimensionInput
                  label="Height"
                  value={state.answers.height}
                  onChange={handleChange('height')}
                  />
              </div>
              {state.formErrors && hasEmptyFields && (
                <small style={{ color: 'red' }}>
                  <FormattedMessage
                    id="pulpoforms.errors.not_blank"
                    defaultMessage="This field cannot be empty"
                    />
                </small>
              )}
            </div>
          </>
        )}
        {/* Notes */}
        <div>
          <Collapsible
            adp
            title="Note:"
            openOnMount={false}
            collapsibleHeight="0"
          >
            {notes?.length !== 0 && (
              <div style={{ height: 'auto' }}>
                {notes?.map((ele, i) => <p>{`(${i + 1}) ${ele}`}</p>)}
              </div>
            )}
          </Collapsible>
        </div>
        {/* Static Default fields - Attachments and Signature */}
        {reqAttach?.length !== 0 && (
          <div>
            <Collapsible
              adp
              title="Required Attachments:"
              openOnMount={false}
              collapsibleHeight="0"
              overflowVisible
            >
                <div style={{ height: 'auto' }}>
                  {reqAttach?.map((ele) => {
                    const { attachmentName } = ele;
                    return (
                      <ReqAttachments
                        {...staticFields[0]}
                        handleAnswerChanged={(a, b) => handleAnswerChanged(
                          'req_attachments', a, `${attachmentName}_${b}`
                        )}
                        attachments={state.answers?.req_attachments?.[`${attachmentName}_attachments`]}
                        showFieldErrors={state.formErrors}
                        handleAttachmentFailedAlert={getErrorAlert}
                        handleAutoUploadAttachments={uploadtoS3}
                        getLoadingStatus={getLoadingStatus}
                        entityName="vehicle_permit"
                        handleRemove={handleRemoveAttachments}
                        attachmentName={attachmentName}
                        dateDetails={ele}
                        adpAnswers={state.answers}
                        handleDateChange={(a, b) => handleAnswerChanged(
                          'req_attachments_dates', a, `${attachmentName}_${b}`
                        )}
                        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
                      />
                    );
                  })}
                </div>
            </Collapsible>
          </div>
        )}
        <div>
          <CustomFields
            fields={reqAttach?.length > 0
              ? staticFields.filter(field => field.id !== 'attachments')
              : staticFields}
            answers={state.answers}
            showFormErrors={state.formErrors}
            requiredMap={getRequired(staticFields)}
            handleAttachmentFailedAlert={getErrorAlert}
            handleAutoUploadAttachments={uploadtoS3}
            getLoadingStatus={getLoadingStatus}
            handleRemove={handleRemoveAttachments}
            entityName="vehicle_permit"
            adpAttachments
            isSignatureUpload
            handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            forQuestionMarkHelp
          />
        </div>
      </div>
      <div className={styles.submitButton}>
        <p className={styles.errorMessage}>
          {state.dateError}
          {state.formErrors && !state.dateError && (
            <FormattedMessageWithClass
              id=" "
              defaultMessage="* Please fill all the required fields"
              className={styles.errorMessage}
              tagName="p"
            />
          )}
        </p>
        <div style={{ display: 'flex', gap: '16px' }}>
          {applicationDetails && applicationDetails?.status === 14 && (
            <Button
              action="danger"
              onClick={() => handleConfirmDelete()}
              translationID="assets.delete"
              defaultText="Delete"
            />
          )}
          <Button
            action="primary"
            onClick={() => (handelSubmit(true))}
            translationID="avp.savedraftinspections.new.finishDraft"
            defaultText="Save as Draft"
            disabled={load}
          />
          <Button
            action="secondary"
            onClick={() => (handelSubmit(false))}
            translationID="avp.submit"
            defaultText="Submit"
            disabled={load}
          />
        </div>
      </div>
      </>
    )}
    </div>
  )}
  {currentStep === 'payment' && avpInitiationInfo?.id && (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {avpGetSchemaSettings?.avp_payment_type_for_tenant === 'offline' ? (
        <OfflinePayment handlePayment={handleOfflinePayment} paymentData={invoiceObject?.grandTotal || 0} useApplicantId={avpInitiationInfo?.id} />
      ) : (
        <PaymentPage
          paymentData={invoiceObject?.grandTotal}
          profileCurrency={profile?.portal_airport?.airport_settings?.currency || '$'}
          isAdmin
          handlePayment={handlePayment}
          handelNavigation={handleSkip}
          airportSettings={profile?.portal_airport?.airport_settings}
          paymentModule="vehicle_permit"
        />
      )}
    </div>
  )}
    {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true)} />}
    <DeleteConfirmation
      isActive={confirmDelete}
      onClose={() => toggleConfirmDelete()}
      confirmDelete={() => remove()}
    />
    {approvedData?.count && (
      <Modal
        showIn={state.openApprovalWarning}
        onClose={() => setState({ ...state, openApprovalWarning: false })}
        width="500px"
        minHeight="20%"
        centered
      >
        <div className={badgeStyles.newTask}>
          <div className={badgeStyles.closeicon}
            style={{ padding: '15px 15px 15px 15px' }}
          >
            <FormattedMessage
              tagName="h4"
              id="adp.log.suspend.application"
              defaultMessage={'Start Application'}
            />
            <Clickable onClick={() => setState({ ...state, openApprovalWarning: false })}>
              <img
                src={closeIcon}
                style={{ cursor: 'pointer' }}
                alt="closeIcon"
                className="drag-icon"
              />
            </Clickable>
          </div>
          <div className={badgeStyles.subHeading} style={{ fontWeight: '500' }}>
          <div>
          <FormattedMessage
            tagName="h5"
            id="adp.log.reactivate.warning.message.approved"
            defaultMessage="The permit holder already has an approved application.
            Please disable or renew the existing approved application before initiating a new application."
          />
          </div>
          </div>
        </div>
      </Modal>
    )}
    </>
  );
};

export default AvpInitiateForm;
